module.exports = __webpack_public_path__ + "static/media/ks_background_tablet.55a3a6db.jpg";